module.exports = __webpack_public_path__ + "static/assets/amex.fd6c3d4.png";